import type { SceneObject } from '../../../types/engine.types';

/**
 * Group scene objects by their island ID
 *
 * @param objects The objects to group
 * @returns Map of island ID to objects
 */
export const groupObjectsByIslandCfn = (
	objects: SceneObject[]
): Map<string, SceneObject[]> => {
	const byIsland = new Map<string, SceneObject[]>();

	for (const obj of objects) {
		const islandId = obj.metadata.islandId || 'floor';
		if (!byIsland.has(islandId)) {
			byIsland.set(islandId, []);
		}
		byIsland.get(islandId)!.push(obj);
	}

	return byIsland;
};
